import { formatName, formatEmail, formatPhone } from '../lib/format';
import PageContent from '../components/ui/PageContent';
import PageHeader from '../components/ui/PageHeader';
import { useSelector } from 'react-redux';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Section from '../components/Section';
import { BuildingIcon, MapPinIcon, UsersIcon } from '../components/NavIcons';
const WorkerCompany = () => {
    const activeOrgInfo = useSelector(state => state.user.activeOrgInfo)
    const logoUrl = typeof activeOrgInfo?.logo === 'string' ? activeOrgInfo.logo : activeOrgInfo?.logo?.url
    const primaryContactName = [activeOrgInfo?.primaryFirstName, activeOrgInfo?.primaryLastName].filter(Boolean).join(' ') || '-'

    return (
        <div>
            <Header />
            <div className='pageShell'>
                <Sidebar />
                <PageContent as="div" className='pageContent pageContentPadded companyPageContent workerPortalPage'>
                    <PageHeader title={<>Company</>} subtitle={<>Company details and contact information</>} />
                    <div className='workerCompanyHero'>
                        <div className='workerCompanyLogo'>
                            {logoUrl ? <img src={logoUrl} alt={`${activeOrgInfo?.name || 'Company'} logo`} /> : <BuildingIcon />}
                        </div>
                        <div>
                            <h2>{activeOrgInfo?.name || 'Company'}</h2>
                            <p>Organisation information and primary contact details</p>
                        </div>
                    </div>
                    <div className='workerCompanyCardGrid'>
                        <Section title='Business Details' className='companyProfileCard workerCompanyInfoCard' variant='card'>
                            <div className='workerCompanyInfoList'>
                                <div className='workerCompanyInfoRow'><BuildingIcon /><div><span>Company Name</span><strong>{activeOrgInfo?.name || '-'}</strong></div></div>
                                <div className='workerCompanyInfoRow'><BuildingIcon /><div><span>ABN</span><strong>{activeOrgInfo?.abn || '-'}</strong></div></div>
                                <div className='workerCompanyInfoRow'><MapPinIcon /><div><span>Address</span><strong>{activeOrgInfo?.address || '-'}</strong></div></div>
                            </div>
                        </Section>
                        <Section title='Primary Contact' className='companyProfileCard workerCompanyInfoCard' variant='card'>
                            <div className='workerCompanyInfoList'>
                                <div className='workerCompanyInfoRow'><UsersIcon /><div><span>Name</span><strong>{formatName(primaryContactName)}</strong></div></div>
                                <div className='workerCompanyInfoRow'><UsersIcon /><div><span>Contact Number</span><strong>{formatPhone(activeOrgInfo?.contactNo || '-')}</strong></div></div>
                                <div className='workerCompanyInfoRow'><UsersIcon /><div><span>Email</span><strong>{formatEmail(activeOrgInfo?.primaryEmail || '-')}</strong></div></div>
                            </div>
                        </Section>
                    </div>
                </PageContent>
            </div>
        </div>
    )
}

export default WorkerCompany
